import * as canvas from 'canvas'
import DatasetTable from 'scoreboard/datasets/model/dataset-table'
import wrapModel from 'scoreboard/components/wrap-model'
import MockSync from 'scoreboard/components/mock-sync'

var Wob = canvas.Wob.extend({
	// use a mocked sync so that changes aren't sent to the server immediately
	sync: MockSync,
	idAttribute: 'id',

	initialize: function() {
		const widget = this.get('widget')
		const table = widget && widget.table
		canvas.Wob.prototype.initialize.apply(this, arguments)
		if (table) {
			this.widget.table = wrapModel(table, DatasetTable)
			// get rid of the actual table in the widget's attributes
			this.widget.unset('table')
		}
	}
})

export default Wob

Wob.__filename__ = 'dashboards/display/wob.js'
